import { Box } from "@mui/material";
import { Droppable } from "react-beautiful-dnd";
import CoverageDraggable from "./CoverageDraggable";

const CoverageDroppable = ({ systemChoice, questionCitationsPerSystemChoice, coverageDndType, droppableType, coverageChoice, inspection }) => {
  
  const getFilteredQuestionCitations = () => {
    const citations = questionCitationsPerSystemChoice || [];
    
    return citations
      .filter(c => c !== undefined)
      .sort((a, b) => {
        const orderA = a?.detail?.sortOrder ?? Number.MAX_SAFE_INTEGER;
        const orderB = b?.detail?.sortOrder ?? Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
      });
  };
  
  const filteredQuestionCitations = getFilteredQuestionCitations();
  
  return (
    <Box>
      <Droppable droppableId={systemChoice?.code_table_uid} type={droppableType || coverageDndType}>
        {(provided) => (
          <Box {...provided.droppableProps} ref={provided.innerRef}>
            {filteredQuestionCitations.map((questionCitation, index) => {
              return <CoverageDraggable key={questionCitation.code} questionCitation={questionCitation} index={index} type={coverageDndType}/>;
            })}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  );
};

export default CoverageDroppable;
